define.alias("shared/errors/media-library", "media/errors/media-library");